import { ethers } from 'ethers';
import MethaTokenArtifact from './abis/MethaToken.json';
import MethaCrowdsaleArtifact from './abis/MethaCrowdsale.json';
import OpenGovernanceArtifact from './abis/OpenGovernance.json';
import AuditingPoolArtifact from './abis/AuditingPool.json';
import AuditorRegistryV2Artifact from './abis/AuditorRegistryV2.json';

export const CHAIN_ID = 11155111; // Sepolia

// v3 deployment — see D:\metha\metha-api\migration_output\deploy_output_*.json
// (2026-05-13). The previous v1/v2 set is preserved on-chain but no longer
// canonical; this file is the source of truth for the metha-client landing.
export const ADDRESSES = {
  EternalStorage:    '0xD81fFB850e44dd131D30E94eeD033CB9c8c546d9',
  MethaToken:        '0x0A1e366572f63bCa45A66dE4F5F1Ab5A62b3E16c',
  OpenGovernance:    '0x7BF8dd021477A44eD0F4b5eB48cB80cfb594917B',
  MethaCrowdsale:    '0x7B96b7e7670C6330b5F4f8b3F46245e4F49FF560',
  AuditingPool:      '0xD301Cff18Cec35F2c698a0fD7DFf81AF81098571',
  AuditorRegistryV2: '0xDead08DfFa69FF1bde30A72E4BD993A67c61Ee03',
};

// Set REACT_APP_INFURA_URL in metha-client/.env for read-only fallback
const INFURA_RPC = process.env.REACT_APP_INFURA_URL || '';

/**
 * Returns a read-only provider (Infura) or a Web3Provider (MetaMask).
 */
export function getProvider() {
  if (window.ethereum) {
    return new ethers.providers.Web3Provider(window.ethereum);
  }
  if (INFURA_RPC) {
    return new ethers.providers.JsonRpcProvider(INFURA_RPC);
  }
  throw new Error('No provider available: install MetaMask or set REACT_APP_INFURA_URL');
}

/**
 * Requests wallet access and returns a signer.
 * Always requires window.ethereum (MetaMask or compatible).
 */
export async function getSigner() {
  if (!window.ethereum) {
    throw new Error('No wallet detected. Please install MetaMask.');
  }
  const provider = new ethers.providers.Web3Provider(window.ethereum);
  await provider.send('eth_requestAccounts', []);
  const network = await provider.getNetwork();
  if (Number(network.chainId) !== CHAIN_ID) {
    throw new Error(`Wrong network. Please switch MetaMask to Sepolia (chainId ${CHAIN_ID}).`);
  }
  return provider.getSigner();
}

/**
 * Returns contract instances bound to the given signer or provider.
 * Pass a Signer for write operations, a Provider for read-only.
 */
export function getContracts(signerOrProvider) {
  const sp = signerOrProvider || getProvider();
  return {
    token:        new ethers.Contract(ADDRESSES.MethaToken,        MethaTokenArtifact.abi,        sp),
    crowdsale:    new ethers.Contract(ADDRESSES.MethaCrowdsale,    MethaCrowdsaleArtifact.abi,    sp),
    governance:   new ethers.Contract(ADDRESSES.OpenGovernance,    OpenGovernanceArtifact.abi,    sp),
    auditingPool: new ethers.Contract(ADDRESSES.AuditingPool,      AuditingPoolArtifact.abi,      sp),
    registry:     new ethers.Contract(ADDRESSES.AuditorRegistryV2, AuditorRegistryV2Artifact.abi, sp),
  };
}
